import { http } from '@pendo/http';
import { environmentBucket } from '@/settings/environment.utils';

export function getJsonFromCDN ({ file }) {
    return http
        .get(`https://${environmentBucket(true)}/json/listen/${file}.json`, {
            withCredentials: false,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getDataFromGcs (gcsUrl) {
    return http
        .get(gcsUrl, {
            withCredentials: false,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
